import React from 'react';

import { Oval } from 'react-loader-spinner'
import {
    Button,
    Col,
    Row,
    CustomInput,
    Navbar,
    Nav,
    NavLink,
    Spinner,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Label,
    Input,
    Table
} from 'reactstrap';
import Select from "react-select";
import NavBar from '../NavBar/navBar'
import ReactTable from "react-table";
import { connect } from "react-redux";
import eyeIcon from '../../assets/eye.svg'
import listIcon from '../../assets/list.svg'
import deleteIcon from '../../assets/deleteIcon.svg'
import filterOnIcon from '../../assets/filter-enable.svg'
import filterOffIcon from '../../assets/filter-disable.svg'
import uploadIcon from '../../assets/upload.svg'
import deleteIconRed from '../../assets/delete-red-outline.svg'
import {
    fetchFilterOptions,
    saveSample,
    deleteResult,
    fetchBuilding,
    fetchLocationList,
    updateSample,
    fetchResultInitialState,
    updateResultStateFilters,
    downloadBiomeResultData,
    uploadResults,
    deleteMultipleResult
} from '../../actions'
import radioButton from '../../assets/radioButton.svg'
import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg'
import { NavLink as RRNavLink } from 'react-router-dom';
import Pagination from '../Pagination/pagination'
import moment from 'moment';
import MultiSelect from '@khanacademy/react-multi-select';
import { toast, ToastContainer } from 'react-toastify';
import isEqual from "react-fast-compare";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import './microbiomeResultsList.css'
import { reactPlugin, appInsights } from "../../AppInsights";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import Tour from '../../Tour';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faUpload } from '@fortawesome/free-solid-svg-icons';
import CustomToolTip from '../SubComponents/CustomTooltip/customTooltip';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

let errorDetails = ""
// const ExcelFile = ExcelFile;
// const ExcelSheet = ExcelFile.ExcelSheet;
// const ExcelColumn = ExcelFile.ExcelColumn;
const dataset = []


var data = {
    type_of_samples: "",
    type_of_analysis: "Microbiome",
    organism: "",
    date_time_after: null,
    date_time_before: null,
    location: "",
    batch_no: "",
    reference_genome: "",
    floor: "",
    building: "",
    complex_type: "",
    novel_type: "",
    sequence_type: "",
    analysis_result_data: "",
}


class microbiomeResultsList extends React.Component {
    constructor(props) {
        super(props)
        this.props.fetchResultInitialState()
        this.props.fetchFilterOptions()
        this.props.fetchBuilding()
        this.props.fetchLocationList()
        this.applyFilter = this.applyFilter.bind(this)
        this.onChangeFromDate = this.onChangeFromDate.bind(this)
        this.onChangeToDate = this.onChangeToDate.bind(this)
        this.toggle = this.toggle.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
        this.state = {
            ...this.props.initialState,
            fileName: "Results_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
            loader: false,
            type: "direct",
            toggleUploadModal: false,
            isDeleteModalOpen: false,
            deleteSampleID: "",
            deleteID: "",
            isFilterEnabled: false,
            filtered: [],
            type_of_samples: undefined,
            type_of_analysis: undefined,
            organism: undefined,
            location_id: undefined,
            reference_genome: undefined,
            analysis_result_data: undefined,
            sequence_type: undefined,
            complex_type: undefined,
            novel_type: undefined,
            other_analysis: undefined,
            filterCount: 0,
            radio: {},
            checked: [],
            isMultiDeleteModalOpen: false,
            loaderBiomeResults: true,
            isResultModalOpen: false,
            biomeResult: [],
            biomeResultBarcode: '',
            isChartModalOpen: false,
        }
    }

    filterRenderer = ({ filter, onChange }) =>
        <input
            className='placeholder-icon-input'
            type='text'
            placeholder='Search'
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
        />

    columns = [
        {
            Header: state => (
                <CustomInput
                    type="checkbox"
                    onClick={() => this.selectAll()}
                    id="select-all-samples"
                    checked={this.props.downloadResult.length === this.state.checked.length}
                    intermediate={this.state.checked.length !== 0 && this.props.downloadResult.length > this.state.checked.length}
                    className="custom-selectall-checkbox"

                />),
            id: 'checkbox',
            accessor: str => "checkbox",
            Cell: (row) => {
                let checked = this.state.checked.includes(row.index)
                return <CustomInput type="checkbox" className={checked ? "custom-table-checkbox select-checked" : "custom-table-checkbox"} id={row.original.id} checked={checked} onClick={() => this.handleCheckClick(row.index)} />
            },
            width: 50,
            Filter: () => <div clasName="checkbox-sticky-style"></div>,
            filterable: false,
            headerClassName: 'checkbox-sticky-style',
            className: 'checkbox-sticky-style'
        },

        {
            Header: 'Sample ID',
            accessor: 'sample.sample_id',
            headerClassName: "border-cells",
            className: "border-cells",
            Filter: this.filterRenderer,
            width: 120
        },
        {
            Header: () => <><span id="EFBarcode">EF Barcode</span>
                <CustomToolTip placement="top" target="EFBarcode" hide={true} text="Eurofins generated barcode" /></>,
            accessor: 'sample.barcode',
            headerClassName: "border-cells",
            className: "border-cells",
            Filter: this.filterRenderer,
            width: 160,
        },
        {
            Header: 'Batch Number',
            accessor: 'sample.batch_no',
            headerClassName: "border-cells",
            className: "border-cells",
            Filter: this.filterRenderer,
            width: 120,
        },
        {
            Header: 'Type of Sample',
            Filter: ({ filter, onChange }) => {
                return this.customFilter({ field: "type_of_samples", filter, onChange })
            },
            accessor: 'sample.type_of_samples',
            headerClassName: "border-cells",
            className: "border-cells",
            width: 120,
        },
        {
            Header: 'Type of Analysis',
            accessor: 'sample.type_of_analysis',
            headerClassName: "border-cells",
            className: "border-cells",
            Filter: ({ filter, onChange }) => {
                return this.customFilter({ field: "type_of_analysis", filter, onChange })
            },
            width: 120,
        },
        {
            Header: 'Organism',
            accessor: 'sample.organism',
            headerClassName: "border-cells",
            className: "border-cells",
            Filter: ({ filter, onChange }) => {
                return this.customFilter({ field: "organism", filter, onChange })
            },
            width: 120,
        },
        {
            Header: 'Location ID',
            id: 'location_id',
            accessor: "sample.location.location_id",
            Cell: (row) => {
                let currentRow = row.original.sample
                if (currentRow.unit) {
                    return <div>{currentRow.location.location_id + ', ' + currentRow.unit.unit_id}</div>
                }
                else {
                    return <div>{currentRow.location.location_id}</div>
                }
            },
            headerClassName: "border-cells",
            className: "border-cells",
            Filter: ({ filter, onChange }) => {
                return this.customFilter({ field: "location_id", filter, onChange })
            },
            width: 180,
        },
        {
            Header: 'Date & Time',
            accessor: 'date_time',
            Cell: (props) => {
                let date = new Date(props.original.sample.date_time)
                date = moment(date).format('MMM D, YYYY HH:mm')
                return <span>{date}</span>
            },
            headerClassName: "border-cells",
            className: "border-cells",
            filterable: false,
            width: 170
        },
        {
            Header: 'Comments',
            accessor: 'sample.comments',
            headerClassName: "border-cells",
            className: "border-cells",
            Filter: this.filterRenderer,
            width: 150
        },
        {
            Header: 'Species',
            accessor: 'analysis_result_data.result',
            headerClassName: "border-cells",
            className: "border-cells",
            Cell: (row) => (<>
                {row.original.sample.type_of_analysis === "Microbiome" && row.original.analysis_result_data ?
                    <>
                        {(Object.keys(row.original.analysis_result_data.result).length > 3) ?
                            <p>4 or more Species</p>
                            :
                            <>
                                {Object.entries(row.original.analysis_result_data.result)
                                    .map(([key, value]) =>
                                        <p>{key}</p>
                                    )}
                            </>
                        }
                    </>
                    :
                    null
                }
            </>),
            filterable: false,
            width: 120
        },
        {
            Header: 'Reads',
            accessor: 'analysis_result_data.result',
            headerClassName: "border-cells",
            className: "border-cells",
            Cell: (row) => (<>
                {row.original.sample.type_of_analysis === "Microbiome" && row.original.analysis_result_data ?
                    <>
                        {(Object.keys(row.original.analysis_result_data.result).length > 3) ?
                            <>
                                <a className="biome-result-link" onClick={() => { this.toggleResultModal(); this.setResultModal(row.original.analysis_result_data.result, row.original.sample.barcode) }}>View results</a>
                                <Modal isOpen={this.state.isResultModalOpen} toggle={this.toggleResultModal} size="lg">
                                    <ModalHeader toggle={this.toggleResultModal} className="edit-popup">View Microbiome Results</ModalHeader>
                                    <ModalBody className="upload-body">
                                        <p>EF Barcode: <b>{this.state.biomeResultBarcode}</b></p>
                                        <Table striped bordered hover size="sm">
                                            <thead>
                                                <tr>
                                                    <th>Species</th>
                                                    <th>Reads</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.entries(this.state.biomeResult)
                                                    .map(([key, value]) =>
                                                        <tr>
                                                            <td>{key}</td>
                                                            <td>{value}%</td>
                                                        </tr>
                                                    )}
                                            </tbody>
                                        </Table>
                                    </ModalBody>
                                </Modal>
                            </>
                            :
                            <>
                                {Object.entries(row.original.analysis_result_data.result)
                                    .map(([key, value]) =>
                                        <p>{value}%</p>
                                    )}
                            </>
                        }

                    </>
                    :
                    null
                }
            </>),
            filterable: false,
            width: 120
        },
    ]

    componentDidMount = () => {
        let persist_root = localStorage.getItem('persist:root')
        var root = JSON.parse(persist_root);
        var results_data = JSON.parse(root.results_data)
        this.applyFilter()
        this.props.downloadBiomeResultData(data).then(
            response => {
                this.setState({ loaderBiomeResults: false })
            }
        )
        if (results_data.downloadResultData === undefined || results_data.downloadResultData.length === 0) {
            this.setState({ loaderBiomeResults: true })
        }
        else {
            this.setState({ loaderBiomeResults: false })
        }
    }

    toggleFilter = () => {
        const filtered = this.state.filtered
        this.setState({
            isFilterEnabled: !this.state.isFilterEnabled,
            filtered: filtered,
        });
    }
    selectAll = () => {
        this.setState({
            checked: this.state.checked.length < this.props.downloadResult.length ? [...Array(this.props.downloadResult.length).keys()] : []
        })
    }

    handleCheckClick = (value) => {
        this.setState(prevState => ({
            checked: prevState.checked.includes(value) ? [...prevState.checked.filter((val) => val !== value)] : [...prevState.checked, value],
        }))
    }

    handleButtonClick = (e, row) => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteSampleID: row.original.sample.sample_id ? row.original.sample.sample_id : "",
            deleteID: row.id ? row.id : row.original.id ? row.original.id : "",
        }));
    }

    ErrorDetails = () => {
        appInsights.trackTrace({ message: errorDetails, properties: { page: "results" }, severityLevel: SeverityLevel.Verbose })
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    pictureData = (data) => {
        var fileName = ""
        if (data != null) {
            fileName = data[0]
        }
        return fileName
    }

    handleOptionChange = (name, name2) => value => {
        var data = { name, name2, value }
        this.props.updateResultStateFilters(data)
    }

    getfilters = (filterList) => {
        let arr = []
        if (filterList) {
            filterList.forEach((data) => {
                arr.push({ value: data, label: data })
            })
        }
        return arr
    }

    getBuildings = () => {
        let arr = []
        this.props.buildingList.forEach((building) => {
            arr.push({ value: building.id, label: building.building_name })
        })
        return arr
    }
    toggleUploadModal = () => {
        this.setState(prevState => ({
            isUploadModalOpen: !prevState.isUploadModalOpen,
        }));
    }

    setResultModal = (row, barcode) => {
        this.setState({
            biomeResult: row,
            biomeResultBarcode: barcode
        })
    }

    toggleResultModal = () => {
        this.setState(prevState => ({
            isResultModalOpen: !prevState.isResultModalOpen,
        }));
    }

    toggleChartModal = () => {
        this.setState(prevState => ({
            isChartModalOpen: !prevState.isChartModalOpen
        }));
    }

    getFloors = () => {
        let arr = []
        let floors = this.props.buildingList
        for (let i = 0; i < floors.length; i++) {
            let f = floors[i].floors
            for (let j = 0; j < f.length; j++) {
                arr.push({ value: f[j].id, label: floors[i].building_name + ',' + f[j].floor_name })
            }
        }
        return arr
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.initialState, this.props.initialState)) {
            this.setState(this.props.initialState);
        }
    }

    deleteSample = () => {
        const filtered = this.state.filtered;
        const filterCount = this.state.filterCount;
        const type_of_samples = this.state.type_of_samples;
        const type_of_analysis = this.state.type_of_analysis;
        const organism = this.state.organism;
        const location_id = this.state.location_id;
        const reference_genome = this.state.reference_genome;
        const sequence_type = this.state.sequence_type;
        const complex_type = this.state.complex_type;
        const novel_type = this.state.novel_type;
        const other_analysis = this.state.other_analysis;
        this.props.deleteResult(this.state.deleteID).then(response => {
            if (response.status === 204) {
                let message = "Result List Deleted Successfully!"
                appInsights.trackEvent({ name: 'Result Deleted', properties: { id: this.state.deleteID } });
                appInsights.trackTrace({ message: message, properties: { id: this.state.deleteID }, severityLevel: SeverityLevel.Information })
                toast.success(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.props.downloadBiomeResultData(data)
                this.setState({
                    isFilterEnabled: true,
                    filtered: filtered,
                    filterCount: filterCount,
                    type_of_samples: type_of_samples,
                    type_of_analysis: type_of_analysis,
                    organism: organism,
                    location_id: location_id,
                    reference_genome: reference_genome,
                    sequence_type: sequence_type,
                    complex_type: complex_type,
                    novel_type: novel_type,
                    other_analysis: other_analysis
                })
            }
            else {
                let message = "Result List couldn't be deleted!"
                appInsights.trackTrace({ message: message, properties: { id: this.state.deleteID }, severityLevel: SeverityLevel.Error });
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.setState({
                    isFilterEnabled: true,
                    filtered: filtered,
                    filterCount: filterCount,
                    type_of_samples: type_of_samples,
                    type_of_analysis: type_of_analysis,
                    organism: organism,
                    location_id: location_id,
                    reference_genome: reference_genome,
                    sequence_type: sequence_type,
                    complex_type: complex_type,
                    novel_type: novel_type,
                    other_analysis: other_analysis
                })
            }
            this.resetData()
        })
            .catch(() => {
                let message = "Result couldn't be deleted!"
                appInsights.trackTrace({ message: message, properties: { id: this.state.deleteID }, severityLevel: SeverityLevel.Error });
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.resetData()
            })
    }

    deleteMultipleSamples = () => {
        const filtered = this.state.filtered;
        const filterCount = this.state.filterCount;
        const type_of_samples = this.state.type_of_samples;
        const type_of_analysis = this.state.type_of_analysis;
        const organism = this.state.organism;
        const location_id = this.state.location_id;
        const reference_genome = this.state.reference_genome;
        const sequence_type = this.state.sequence_type;
        const complex_type = this.state.complex_type;
        const novel_type = this.state.novel_type;
        const other_analysis = this.state.other_analysis;

        let ids = this.state.checked.map((data) => this.props.downloadResult[data].id)
        this.props.deleteMultipleResult(ids).then(response => {
            if (response.status === 204) {
                let message = "Results Deleted Successfully!"
                appInsights.trackEvent({ name: 'Results Deleted', properties: { id: ids } });
                appInsights.trackTrace({ message: message, properties: { id: ids }, severityLevel: SeverityLevel.Information })
                toast.success(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.props.downloadBiomeResultData(data)
                this.setState({
                    filtered: filtered,
                    filterCount: filterCount,
                    type_of_samples: type_of_samples,
                    type_of_analysis: type_of_analysis,
                    organism: organism,
                    location_id: location_id,
                    reference_genome: reference_genome,
                    sequence_type: sequence_type,
                    complex_type: complex_type,
                    novel_type: novel_type,
                    other_analysis: other_analysis
                })
            }
            else {
                let message = "Results couldn't be deleted!"
                appInsights.trackTrace({ message: message, properties: { id: ids }, severityLevel: SeverityLevel.Error });
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.setState({
                    filtered: filtered,
                    filterCount: filterCount,
                    type_of_samples: type_of_samples,
                    type_of_analysis: type_of_analysis,
                    organism: organism,
                    location_id: location_id,
                    reference_genome: reference_genome,
                    sequence_type: sequence_type,
                    complex_type: complex_type,
                    novel_type: novel_type,
                    other_analysis: other_analysis
                })
            }
            this.resetData()
        })
            .catch(() => {
                let message = "Results couldn't be deleted!"
                appInsights.trackTrace({ message: message, properties: { id: ids }, severityLevel: SeverityLevel.Error });
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.resetData()
            })
    }

    toggleDeleteModal = () => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteLocationId: ""
        }));
    }

    toggleMultiDeleteModal = () => {
        this.setState(prevState => ({
            isMultiDeleteModalOpen: !prevState.isMultiDeleteModalOpen,
        }));
    }

    applyFilter = () => {
        var data = {
            type_of_samples: this.state.sampleTypeFilter ? this.state.sampleTypeFilter.toString() : "",
            type_of_analysis: "Microbiome",
            organism: this.state.organismFilter ? this.state.organismFilter.toString() : "",
            date_time_after: this.state.fromDate ? moment.utc(new Date(this.state.fromDate)).format("YYYY-MM-DD") : null,
            date_time_before: this.state.toDate ? moment.utc(new Date(this.state.toDate)).format("YYYY-MM-DD") : null,
            location: this.state.locationFilter ? this.state.locationFilter.toString() : "",
            batch_no: this.state.batchFilter ? this.state.batchFilter.toString() : "",
            reference_genome: this.state.referenceFilter ? this.state.referenceFilter.toString() : "",
            floor: this.state.floorFilter ? this.state.floorFilter.toString() : "",
            building: this.state.buildingFilter ? this.state.buildingFilter.toString() : "",
            complex_type: this.state.complexFilter ? this.state.complexFilter.toString() : "",
            novel_type: this.state.novelFilter ? this.state.novelFilter.toString() : "",
            sequence_type: this.state.sequenceFilter ? this.state.sequenceFilter.toString() : "",
            analysis_result_data: this.state.snpFilter ? this.state.snpFilter.toString() : "",
        }
        this.props.downloadBiomeResultData(data)
    }

    getDatetime = date => {
        let datetime = new Date()
        datetime.setDate(date.getDate());
        datetime.setMonth(date.getMonth());
        datetime.setFullYear(date.getFullYear());
        return datetime
    }

    onChangeFromDate = (date) => {
        this.setState({ fromDate: this.getDatetime(date) })
    }

    onChangeToDate = (date) => {
        this.setState({ toDate: this.getDatetime(date) })
    }

    handleValueChange = (event) => {
        this.setState({
            ...this.state,
            [event.target.name]: event.currentTarget.value
        })
    }

    resetData = () => {
        this.props.fetchResultInitialState()
        this.setState({
            isOpen: this.state.isOpen,
            isDeleteModalOpen: false,
            checked: [],
            isMultiDeleteModalOpen: false
        })
        this.props.downloadBiomeResultData(data)
    }

    getLocations = () => {
        let arr = []
        this.props.locationList.forEach((location) => {
            if (!location.unit) {
                arr.push({ value: location.location_id, label: location.location_id })
            }
        })
        return arr
    }

    getFileName = () => {
        let Filename = "Results_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        this.setState({ fileName: Filename })
    }

    onChangeFile = event => {
        let allowedExtensions = ["xlsx"]
        let file = event.target.files
        if (file.length > 0 && !allowedExtensions.includes(file[0].name.split('.').slice(-1)[0])) {
            appInsights.trackTrace({ message: "Incorect file format, Please choose an Excel file (.xlsx)", properties: { page: "results" }, severityLevel: SeverityLevel.Verbose })
            toast.warn("Incorect file format, Please choose an Excel file (.xlsx)", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else {
            file[0]['displayName'] = file[0].name.split(".")[0];
            if (file[0]['displayName'].length > 15) file[0]['displayName'] = file[0]['displayName'].substring(0, 15) + '...';
            this.setState({ resultFile: file[0] });
        }
    }

    clearUpload = () => {
        this.setState({ resultFile: undefined });
    }

    uploadResults = () => {
        if (!this.state.resultFile) {
            let message = "Results Upload failed. Please choose a file!"
            appInsights.trackTrace({ message: message, properties: { page: "results" }, severityLevel: SeverityLevel.Verbose })
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else {
            this.setState({ loader: true })
            this.props.uploadResults(this.state.resultFile, false, true).then((res) => {
                if (res && res.data) {
                    this.setState({ loader: false, isUploadModalOpen: false, resultFile: "" })
                    this.props.downloadBiomeResultData(data)
                    let total = res.data.number_of_results_uploaded + res.data.number_of_invalids + res.data.number_of_duplicates
                    let uploaded = res.data.number_of_results_uploaded
                    let message = (uploaded) + " out of " + (total) + " results uploaded successfully."
                    appInsights.trackEvent({ name: 'Results Uploaded', properties: { uploaded: uploaded, invalid: res.data.number_of_invalids, duplicates: res.data.number_of_duplicates } });
                    appInsights.trackTrace({ message: 'Results Uploaded', properties: { uploaded: uploaded, invalid: res.data.number_of_invalids, duplicates: res.data.number_of_duplicates }, severityLevel: SeverityLevel.Information })
                    toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
                    if (res.status === 203) {
                        message = "Found " + (res.data.number_of_invalids) + " results with invalid data."
                        toast.warn(message, { position: toast.POSITION.BOTTOM_RIGHT })
                    }
                    else if (res.status === 202) {
                        message = "Found " + (res.data.number_of_duplicates) + " duplicate barcodes."
                        toast.warn(message, { position: toast.POSITION.BOTTOM_RIGHT })
                    }
                }
            }).catch((e) => {
                this.setState({ loader: false })
                if (e.status === 400) {
                    let message = ''
                    if (e.data['invalid_headers'] || e.data['result_headers'] || e.data['barcode'])
                        message = "Upload failed due to invalid headers, please refer the template for more updates!!"
                    else if (e.data['empty_data'])
                        message = "Upload failed due to empty data in the file!!"
                    else if (e.data['number_of_invalids'])
                        message = "Upload failed due to invalid data!!"
                    else
                        message = "Upload failed, try again after rechecking the data!!"
                    appInsights.trackTrace({ message: message, properties: { file: this.state.resultFile, page: 'results', error: e }, severityLevel: SeverityLevel.Error })
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    })
                }
                else {
                    let message = "Upload failed due to an unexcpected error!!."
                    appInsights.trackTrace({ message: message, properties: { file: this.state.resultFile, page: 'results', error: e }, severityLevel: SeverityLevel.Error })
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    })
                }
            })
        }
    }

    refineBiomeValue = (allResults) => {
        let val = allResults['result']
        let res = []
        Object.entries(val)
            .map(([key, value]) =>
                res.push(value + '% ' + key)
            )
        res = res.join()
        return res
    }

    customFilter = ({ field, filter, onChange }) => {
        let filterStyle = { menuPortal: base => ({ ...base, zIndex: 9999 }) }
        switch (field) {
            case 'type_of_samples':
                return (
                    <Select
                        className="custom-filters-select"
                        onChange={entry => {
                            this.setState({ type_of_samples: entry });
                            entry && entry.length > 0 ? this.onFilteredChangeCustom(
                                entry.map(o => {
                                    return o.value;
                                })
                                ,
                                "sample.type_of_samples"
                            ) :
                                this.onFilteredChangeCustom('', "sample.type_of_samples")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.type_of_samples}
                        isMulti={true}
                        options={this.props.downloadResult.map(item => {
                            return item.sample.type_of_samples
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                );
            case 'type_of_analysis':
                return (
                    <Select
                        className="custom-filters-select"
                        onChange={entry => {
                            this.setState({ type_of_analysis: entry });
                            entry && entry.length > 0 ? this.onFilteredChangeCustom(
                                entry.map(o => {
                                    return o.value;
                                })
                                ,
                                "sample.type_of_analysis"
                            ) :
                                this.onFilteredChangeCustom('', "sample.type_of_analysis")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.type_of_analysis}
                        isMulti={true}
                        options={this.props.downloadResult.map(item => {
                            return item.sample.type_of_analysis
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case 'organism':
                return (
                    <Select
                        className="custom-filters-select"
                        onChange={entry => {
                            this.setState({ organism: entry });
                            entry && entry.length > 0 ? this.onFilteredChangeCustom(
                                entry.map(o => {
                                    return o.value;
                                })
                                ,
                                "sample.organism"
                            ) :
                                this.onFilteredChangeCustom('', "sample.organism")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.organism}
                        isMulti={true}
                        options={this.props.downloadResult.map(item => {
                            return item.sample.organism
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case 'location_id':
                return (
                    <Select
                        className="custom-filters-select"
                        onChange={entry => {
                            this.setState({ location_id: entry });
                            entry && entry.length > 0 ? this.onFilteredChangeCustom(
                                entry.map(o => {
                                    return o.value;
                                })
                                ,
                                "location_id"
                            ) :
                                this.onFilteredChangeCustom('', "location_id")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.location_id}
                        isMulti={true}
                        options={this.props.downloadResult.map(item => {
                            return item.sample.location.location_id
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case 'reference_genome':
                return (
                    <Select
                        className="custom-filters-select"
                        onChange={entry => {
                            this.setState({ reference_genome: entry });
                            entry && entry.length > 0 ? this.onFilteredChangeCustom(
                                entry.map(o => {
                                    return o.value;
                                })
                                ,
                                "sample.reference_genome"
                            ) :
                                this.onFilteredChangeCustom('', "sample.reference_genome")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.reference_genome}
                        isMulti={true}
                        options={this.props.downloadResult.map(item => {
                            return item.sample.reference_genome
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case 'sequence_type':
                return (
                    <Select
                        className="custom-filters-select"
                        onChange={entry => {
                            this.setState({ sequence_type: entry });
                            entry && entry.length > 0 ? this.onFilteredChangeCustom(
                                entry.map(o => {
                                    return o.value;
                                })
                                ,
                                "sequence_type"
                            ) :
                                this.onFilteredChangeCustom('', "sequence_type")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.sequence_type}
                        isMulti={true}
                        options={this.props.downloadResult.map(item => {
                            return item.sequence_type
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case 'complex_type':
                return (
                    <Select
                        className="custom-filters-select"
                        onChange={entry => {
                            this.setState({ complex_type: entry });
                            entry && entry.length > 0 ? this.onFilteredChangeCustom(
                                entry.map(o => {
                                    return o.value;
                                })
                                ,
                                "complex_type"
                            ) :
                                this.onFilteredChangeCustom('', "complex_type")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.complex_type}
                        isMulti={true}
                        options={this.props.downloadResult.map(item => {
                            return item.complex_type
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case 'novel_type':
                return (
                    <Select
                        className="custom-filters-select"
                        onChange={entry => {
                            this.setState({ novel_type: entry });
                            entry && entry.length > 0 ? this.onFilteredChangeCustom(
                                entry.map(o => {
                                    return o.value;
                                })
                                ,
                                "novel_type"
                            ) :
                                this.onFilteredChangeCustom('', "novel_type")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.novel_type}
                        isMulti={true}
                        options={this.props.downloadResult.map(item => {
                            return item.novel_type
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            case 'other_analysis':
                return (
                    <Select
                        className="custom-filters-select"
                        onChange={entry => {
                            this.setState({ other_analysis: entry });
                            entry && entry.length > 0 ?
                                this.onFilteredChangeCustom(
                                    entry && entry.length > 0 && entry.map(o => {
                                        return o.value;
                                    })
                                    ,
                                    "other_analysis"
                                ) :
                                this.onFilteredChangeCustom('', "other_analysis")
                        }}
                        menuPortalTarget={document.body}
                        styles={filterStyle}
                        value={this.state.other_analysis}
                        isMulti={true}
                        options={this.props.downloadResult.map(item => {
                            return item.other_analysis
                        })
                            .filter((item, i, s) => s.lastIndexOf(item) === i).map((o, i) => {
                                return { id: i, value: o, label: o };
                            })}
                    />
                )
            default:
                return <Select />
        }
    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = [...this.state.filtered];
        let filterCount = 0;
        if (filtered.length > 0) {
            filtered.forEach((filter, i) => {
                if (filter["id"] === accessor) {
                    if (value === "" || !!(value && value.length))
                        filtered.splice(i, 1);
                    else return filter["value"] = value;
                }
            });
        }
        filtered.push({ id: accessor, value: value });
        this.setState({ filtered: filtered }
            , () => this.forceUpdate());
        if (filtered.length > 0) {
            filtered.forEach((filter) => {
                if (typeof (filter["value"]) === "string" && filter["value"].length > 0) {
                    filterCount = filterCount + 1
                }
                else {
                    filterCount = filterCount + filter["value"].length
                }
            });
            this.setState({
                filterCount: filterCount
            })
        }
    };

    resetFilters = () => {
        this.setState({
            filterCount: 0,
            filtered: [],
            type_of_samples: [],
            type_of_analysis: [],
            organism: [],
            location_id: [],
            reference_genome: [],
            sequence_type: [],
            complex_type: [],
            novel_type: [],
            other_analysis: []
        })
    }

    getChartData = () => {
        const selectedResults = this.state.checked.map(i => this.props.downloadResult[i]);

        const allSpecies = new Set();
        selectedResults.forEach(result => {
            if (result.analysis_result_data?.result) {
                Object.keys(result.analysis_result_data.result).forEach(s => allSpecies.add(s));
            }
        });

        return selectedResults.map(result => {
            const row = { barcode: result.sample.barcode };
            allSpecies.forEach(species => {
                row[species] = result.analysis_result_data?.result?.[species]
                    ? parseFloat(result.analysis_result_data.result[species])
                    : 0;
            });
            return row;
        });
    }

    getSpeciesList = () => {
        const selectedResults = this.state.checked.map(i => this.props.downloadResult[i]);
        const allSpecies = new Set();
        selectedResults.forEach(result => {
            if (result.analysis_result_data?.result) {
                Object.keys(result.analysis_result_data.result).forEach(s => allSpecies.add(s));
            }
        });
        return [...allSpecies];
    }

    render() {
        return (
            <>
                {window.innerWidth > 900 ?
                    <div className="page-layout">
                        <NavBar />
                        <div className='dashboard-overview samples-page results-page' data-tut="reactour__results" ref={(divElement) => { this.divElement = divElement }}>
                            <div className="dashboard-content-25" >
                                <Row className="sample-list-header" form>
                                    <Navbar className="navbar-results " light expand="md">
                                        <Nav navbar data-tut="reactour__nav">
                                            <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/viewresults"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />All Results</span></NavLink>
                                            <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/trackresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />Track Result</span></NavLink>
                                            <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/snpresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />SNP Result</span></NavLink>
                                            <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding remove-style" activeClassName="active" to="/results/biomeresults/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt='' />Microbiome Result</span></NavLink>
                                            <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/speciesdensity/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt="" />Species Density</span></NavLink>
                                        </Nav>
                                    </Navbar>
                                </Row>
                                <div data-tut="reactour__options" className='sample-input-area'>
                                    <Row form data-tut="reactour__apply">
                                        <Col sm={4} md={3} lg={2}>
                                            <MultiSelect
                                                options={this.getBuildings()}
                                                onSelectedChanged={this.handleOptionChange('buildingFilter', 'filterBuildingList')}
                                                selected={this.state.filterBuildingList}
                                                overrideStrings={{
                                                    selectSomeItems: "Building",
                                                    allItemsAreSelected: 'All Buildings are Selected'
                                                }}
                                                id="buildingFilter"
                                            />
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <MultiSelect
                                                options={this.getFloors()}
                                                onSelectedChanged={this.handleOptionChange('floorFilter', 'filterFloorList')}
                                                selected={this.state.filterFloorList}
                                                overrideStrings={{
                                                    selectSomeItems: "Floor",
                                                    allItemsAreSelected: 'All Floors are Selected'
                                                }}
                                                id="floorFilter"
                                            />
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <MultiSelect
                                                options={this.getLocations()}
                                                selected={this.state.filterLocationList}
                                                onSelectedChanged={this.handleOptionChange('locationFilter', 'filterLocationList')}
                                                overrideStrings={{
                                                    selectSomeItems: "Location",
                                                    allItemsAreSelected: 'All Locations are Selected'
                                                }}
                                                id="locationFilter"
                                            />
                                        </Col>
                                        <Col sm={4} md={3} lg={2}>
                                            <MultiSelect
                                                options={this.getfilters(this.props.filters.organismList)}
                                                selected={this.state.filterOrganismList}
                                                onSelectedChanged={this.handleOptionChange('organismFilter', 'filterOrganismList')}
                                                overrideStrings={{
                                                    selectSomeItems: "Organism",
                                                    allItemsAreSelected: 'All Organisms are Selected'
                                                }}
                                                id="organismFilter"
                                            />
                                        </Col>
                                        <Col isOpen={this.state.isOpen} className="clear-apply-end">
                                            <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                            <Button id="applyFloorButton" type="submit" onClick={this.applyFilter}>Apply</Button>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="grid-data width">
                                <Row className="sample-list-header" form>
                                    <Navbar className="navbar-results" light expand="md">
                                        <Nav navbar data-tut="reactour__floor">
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="" to="/results/biomeresults/"><span className="nav-col"><img src={eyeIcon} className="nav-icons" alt='' />Floor View</span></NavLink>
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/biomeresults/grid-view" ><span className="nav-col"><img src={listIcon} className="nav-icons" alt='' />List View</span></NavLink>
                                        </Nav>
                                    </Navbar>
                                    <Col className="samples-header-right">
                                        {this.state.filterCount > 0 ? <Button
                                            className="filter-button-clear button-size cancel-buttons"
                                            id="export-data-button"
                                            labelColor="#000"
                                            backgroundColor="#FFF"
                                            fullWidth={true}
                                            onClick={() => this.resetFilters()
                                            }
                                        >
                                            X Clear all filters
                                        </Button> : null}
                                        <div className='dropdown-filter' onClick={this.toggleFilter}>
                                            <img src={this.state.isFilterEnabled ? filterOffIcon : filterOnIcon} className='icon-padding' alt='' />
                                            <span className='icon-padding'>{this.state.isFilterEnabled ? "Hide Filter" : "Filter"}</span>
                                        </div>
                                        {this.state.filterCount > 0 ?
                                            <Button className="data-button">
                                                {this.state.filterCount}
                                            </Button>
                                            : null}
                                        <div className={'dropdown-filter' + (this.state.checked.length > 0 ? "" : " samples-options-disabled")} data-tut="reactour__tableDelete" onClick={this.state.checked.length > 0 ? this.toggleMultiDeleteModal : undefined}>
                                            <img src={deleteIcon} className="icon-padding" alt='' /><span className="icon-padding">Delete</span>
                                        </div>
                                        <div
                                            className={'dropdown-filter' + (this.state.checked.length > 0 ? "" : " samples-options-disabled")}
                                            onClick={this.state.checked.length > 0 ? this.toggleChartModal : undefined}
                                        >
                                            <span className="icon-padding">📊 Ver Gráfico</span>
                                        </div>
                                        {this.props.downloadResult && this.props.downloadResult.length > 0 &&
                                            <div style={{ display: "none" }} element={<Button id="export-data-button" className="export-data-button" onClick={this.getFileName} data-tut="reactour__downloads">Download</Button>} filename={this.state.fileName}>
                                                {this.props.downloadResult && this.props.downloadResult.length > 0 ?
                                                    <div data={this.props.downloadResult} name="Results">
                                                        <div label="SampleID" value={(col) => col.sample.sample_id} />
                                                        <div label="EF Barcode" value={(col) => col.sample.barcode} />
                                                        <div label="BatchNumber" value={(col) => col.sample.batch_no} />
                                                        <div label="TypeOfSample" value={(col) => col.sample.type_of_samples} />
                                                        <div label="TypeOfAnalysis" value={(col) => col.sample.type_of_analysis} />
                                                        <div label="OrganismName" value={(col) => col.sample.organism} />
                                                        <div label="LocationID" value={(col) => col.sample.unit ? col.sample.location.location_id + ', ' + col.sample.unit.unit_id : col.sample.location.location_id} />
                                                        <div label="Date_Time" value={(col) => moment(col.sample.date_time).format('MMMM D, YYYY HH:mm')} />
                                                        <div label="Comments" value={(col) => col.sample.comments} />
                                                        <div label="MicrobiomeResults" value={(col) => this.refineBiomeValue(col.analysis_result_data)} />
                                                    </div>
                                                    : null
                                                }
                                            </div>
                                        }
                                        {!localStorage.getItem("guest") ? <Button
                                            className="export-data-button"
                                            id="export-data-button"
                                            labelColor="#000"
                                            backgroundColor="#FFF"
                                            fullWidth={true}
                                            onClick={() => this.toggleUploadModal()}
                                            data-tut="reactour__uploads"
                                        ><img src={uploadIcon} className="nav-icons" alt='' />
                                            Upload Results
                                        </Button> : null}
                                        <Modal isOpen={this.state.isUploadModalOpen} toggle={this.toggleUploadModal} size="lg">
                                            <ModalHeader toggle={this.toggleUploadModal} className="edit-popup">Upload Results</ModalHeader>
                                            <ModalBody className="upload-body">
                                                <Row xs="2">
                                                    <Col>
                                                        <FontAwesomeIcon className="overlay-upload-icon upload-sample-icon-position" icon={faUpload} size="lg" />
                                                        <Input
                                                            className="edit-input-values edit-input-values-file upload-sample-file"
                                                            type="file"
                                                            accept=".xlsx, .csv"
                                                            placeholder="please enter file"
                                                            onClick={(event) => {
                                                                event.target.value = null
                                                            }}
                                                            onChange={this.onChangeFile}
                                                            data-title={'Choose File'}
                                                        />
                                                    </Col>
                                                    <Col className="upload-sample-last">
                                                        {this.state.resultFile ?
                                                            <Col className="upload-filename">
                                                                <Label className="title">{this.state.resultFile.displayName}</Label>
                                                                <img src={deleteIconRed} className="overlay-upload-icon trash-icon" alt=''
                                                                    onClick={this.clearUpload}
                                                                />
                                                            </Col> : <></>}
                                                    </Col>
                                                    <Col>
                                                        <div className="vertical-line"></div>
                                                        <div style={{ display: "none" }} element={<Button id="export-data-button" className="export-data-button  sample-template-button" onClick={this.getFileName}>Download Result Template</Button>} filename={this.state.fileName}>
                                                            <div data={dataset} name="Results">
                                                                <div label="*BarCode" value="barcode" />
                                                                <div label="batchnumber" value="bn" />
                                                                <div label="typeofsample" value="typeOfSample" />
                                                                <div label="*typeofanalysis" value="typeOfAnalysis" />
                                                                <div label="*locationid" value="locationId" />
                                                                <div label="*datetime" value="dateTime" />
                                                                <div label="comments" value="comments" />
                                                                <div label="*results" value="results" />
                                                            </div>
                                                        </div>
                                                        <div className="edit-popup">
                                                            <h5 className="modal-text lowertag lowertag-align">* are mandatory to fill</h5>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </ModalBody>
                                            <ModalFooter className="float-sm-right bottom-options">
                                                <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={this.clearUpload}>Clear</Button>
                                                <Button
                                                    className="button-size custom-button save-upload-delete-button"
                                                    id="export-data-button"
                                                    labelColor="#000"
                                                    backgroundColor="#FFF"
                                                    fullWidth={true}
                                                    onClick={() => this.uploadResults()}
                                                >
                                                    Save
                                                </Button>
                                                {this.state.loader ? <Spinner className="loader-save" size="sm" color="primary" /> : null}
                                            </ModalFooter>
                                        </Modal>

                                    </Col>
                                </Row>
                                {this.state.loaderBiomeResults ?
                                    <>
                                        <div className="loader-result-oval"><Oval color="#243682" height={60} width={60} /></div>
                                        <div className="no-data-msg"> Please wait while we check for Results...</div>
                                    </>
                                    :
                                    <>
                                        {this.props.downloadResult.length > 0 ?
                                            <div>
                                                <div className="sample-table-height" data-tut="reactour__table">
                                                    <ReactTable className="Data-Table"
                                                        PaginationComponent={Pagination}
                                                        data={this.props.downloadResult}
                                                        columns={this.columns}
                                                        showPagination={true}
                                                        minRows={0}
                                                        sortable={false}
                                                        defaultPageSize={5}
                                                        filterable={true}
                                                        filtered={this.state.filtered}
                                                        getTheadFilterTrProps={() => {
                                                            return {
                                                                style: this.state.isFilterEnabled ? {
                                                                }
                                                                    :
                                                                    { display: "none", visibility: "hidden" }
                                                            };
                                                        }}
                                                        onFilteredChange={(filtered, column, value) => {
                                                            this.onFilteredChangeCustom(value, column.id || column.accessor);
                                                        }}
                                                        defaultFilterMethod={(filter, row, column) => {
                                                            const id = filter.pivotId || filter.id;
                                                            if (typeof filter.value === "object" && filter.value !== null) {
                                                                return row[id] !== undefined
                                                                    ? filter.value.indexOf(row[id]) > -1
                                                                    : true;
                                                            } else {
                                                                return row[id] !== undefined
                                                                    ? String(row[id]).indexOf(filter.value) > -1
                                                                    : true;
                                                            }
                                                        }}
                                                        getTrProps={(state, rowInfo) => {
                                                            if (rowInfo && rowInfo.row) {
                                                                return {
                                                                    onClick: () => { this.handleCheckClick(rowInfo.index) },
                                                                    className: this.state.checked.includes(rowInfo.index) ? "table-selected-row" : "",
                                                                }
                                                            } else {
                                                                return {}
                                                            }
                                                        }
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            :
                                            <>
                                                {this.props.downloadResult.length === 0 ?
                                                    <div className="no-data-msg"> No Results Available</div>
                                                    : null
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </div>
                            <Modal isOpen={this.state.isMultiDeleteModalOpen} toggle={this.toggleMultiDeleteModal}>
                                <ModalHeader toggle={this.toggleMultiDeleteModal} className="edit-popup delete-title">
                                    <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle} />
                                    Warning
                                </ModalHeader>
                                {this.state.checked.length > 1 ?
                                    <ModalBody className="delete-popup-body">
                                        Do you want to delete the {this.state.checked.length} results selected?
                                    </ModalBody> :
                                    <ModalBody className="delete-popup-body">
                                        Do you want to delete the result {this.state.checked.map((data) => this.props.downloadResult[data].sample.barcode)[0]}?
                                    </ModalBody>}
                                <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                                    <Button className="custom-button cancel-button mr-2 custom-dimension" outline color="secondary" onClick={this.toggleMultiDeleteModal}>No</Button>
                                    <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteMultipleSamples}>Yes</Button>
                                </ModalFooter>
                            </Modal>

                            {/* Modal do gráfico — bloco desktop */}
                            <Modal isOpen={this.state.isChartModalOpen} toggle={this.toggleChartModal} size="xl">
                                <ModalHeader toggle={this.toggleChartModal} className="edit-popup">
                                    Abundância Relativa de Espécies
                                </ModalHeader>
                                <ModalBody>
                                    {(() => {
                                        const chartData = this.getChartData();
                                        const species = this.getSpeciesList();
                                        const COLORS = ['#4e79a7', '#f28e2b', '#e15759', '#76b7b2', '#59a14f', '#edc948', '#b07aa1', '#ff9da7', '#9c755f', '#bab0ac'];
                                        return (
                                            <div style={{ width: '100%', height: Math.max(300, chartData.length * 60) }}>
                                                <ResponsiveContainer width="100%" height="100%">
                                                    <BarChart layout="vertical" data={chartData} margin={{ top: 10, right: 30, left: 120, bottom: 10 }}>
                                                        <CartesianGrid strokeDasharray="3 3" />
                                                        <XAxis type="number" domain={[0, 100]} tickFormatter={v => `${v}%`} label={{ value: 'Abundância Relativa (%)', position: 'insideBottom', offset: -5 }} />
                                                        <YAxis type="category" dataKey="barcode" width={110} tick={{ fontSize: 11 }} />
                                                        <Tooltip formatter={(value, name) => [`${value}%`, name]} />
                                                        <Legend verticalAlign="top" />
                                                        {species.map((sp, idx) => (
                                                            <Bar key={sp} dataKey={sp} stackId="a" fill={COLORS[idx % COLORS.length]} />
                                                        ))}
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            </div>
                                        );
                                    })()}
                                </ModalBody>
                                <ModalFooter>
                                    <Button outline color="secondary" onClick={this.toggleChartModal}>Fechar</Button>
                                </ModalFooter>
                            </Modal>

                            <ToastContainer autoClose={3000} />
                            {this.props.isTourOpen ? <Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} /> : null}
                        </div>
                    </div>
                    :
                    <div className='dashboard-overview samples-page' data-tut="reactour__results" ref={(divElement) => { this.divElement = divElement }}>
                        <div className="dashboard-content-25" >
                            <Row className="sample-list-header" form>
                                <Navbar className="navbar-results " light expand="md">
                                    <Nav navbar data-tut="reactour__nav">
                                        <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/viewresults"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />All Results</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/trackresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />Track Result</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/snpresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />SNP Result</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding remove-style" activeClassName="active" to="/results/biomeresults/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt='' />Microbiome Result</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/speciesdensity/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt="" />Species Density</span></NavLink>
                                    </Nav>
                                </Navbar>
                            </Row>
                            <div data-tut="reactour__options" className='sample-input-area'>
                                <Row form>
                                    <Col sm={4} md={3} lg={2}>
                                        <MultiSelect
                                            options={this.getBuildings()}
                                            onSelectedChanged={this.handleOptionChange('buildingFilter', 'filterBuildingList')}
                                            selected={this.state.filterBuildingList}
                                            overrideStrings={{
                                                selectSomeItems: "Building",
                                                allItemsAreSelected: 'All Buildings are Selected'
                                            }}
                                            id="buildingFilter"
                                        />
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <MultiSelect
                                            options={this.getFloors()}
                                            onSelectedChanged={this.handleOptionChange('floorFilter', 'filterFloorList')}
                                            selected={this.state.filterFloorList}
                                            overrideStrings={{
                                                selectSomeItems: "Floor",
                                                allItemsAreSelected: 'All Floors are Selected'
                                            }}
                                            id="floorFilter"
                                        />
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <MultiSelect
                                            options={this.getLocations()}
                                            selected={this.state.filterLocationList}
                                            onSelectedChanged={this.handleOptionChange('locationFilter', 'filterLocationList')}
                                            overrideStrings={{
                                                selectSomeItems: "Location",
                                                allItemsAreSelected: 'All Locations are Selected'
                                            }}
                                            id="locationFilter"
                                        />
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <MultiSelect
                                            options={this.getfilters(this.props.filters.organismList)}
                                            selected={this.state.filterOrganismList}
                                            onSelectedChanged={this.handleOptionChange('organismFilter', 'filterOrganismList')}
                                            overrideStrings={{
                                                selectSomeItems: "Organism",
                                                allItemsAreSelected: 'All Organisms are Selected'
                                            }}
                                            id="organismFilter"
                                        />
                                    </Col>
                                    <Col isOpen={this.state.isOpen} className="clear-apply-end" data-tut="reactour__apply">
                                        <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                        <Button id="applyFloorButton" type="submit" onClick={this.applyFilter}>Apply</Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="grid-data">
                            <Row className="sample-list-header" form>
                                <Navbar className="navbar-results" light expand="md">
                                    <Nav navbar data-tut="reactour__floor">
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="" to="/results/biomeresults/"><span className="nav-col"><img src={eyeIcon} className="nav-icons" alt='' />Floor View</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/biomeresults/grid-view" ><span className="nav-col"><img src={listIcon} className="nav-icons" alt='' />List View</span></NavLink>
                                    </Nav>
                                </Navbar>
                                <Col className="samples-header-right">
                                    {this.state.filterCount > 0 ? <Button
                                        className="filter-button-clear button-size cancel-buttons"
                                        id="export-data-button"
                                        labelColor="#000"
                                        backgroundColor="#FFF"
                                        fullWidth={true}
                                        onClick={() => this.resetFilters()
                                        }
                                    >
                                        X Clear all filters
                                    </Button> : null}
                                    <div className='dropdown-filter' onClick={this.toggleFilter}>
                                        <img src={this.state.isFilterEnabled ? filterOffIcon : filterOnIcon} className='icon-padding' alt='' />
                                        <span className='icon-padding'>{this.state.isFilterEnabled ? "Hide Filter" : "Filter"}</span>
                                    </div>
                                    {this.state.filterCount > 0 ?
                                        <Button className="data-button">
                                            {this.state.filterCount}
                                        </Button>
                                        : null}
                                    <div className={'dropdown-filter' + (this.state.checked.length > 0 ? "" : " samples-options-disabled")} data-tut="reactour__tableDelete" onClick={this.state.checked.length > 0 ? this.toggleMultiDeleteModal : undefined}>
                                        <img src={deleteIcon} className='icon-padding' alt='' /><span className="icon-padding">Delete</span>
                                    </div>
                                    <div
                                        className={'dropdown-filter' + (this.state.checked.length > 0 ? "" : " samples-options-disabled")}
                                        onClick={this.state.checked.length > 0 ? this.toggleChartModal : undefined}
                                    >
                                        <span className="icon-padding">📊 Ver Gráfico</span>
                                    </div>
                                    {this.props.downloadResult && this.props.downloadResult.length > 0 &&
                                        <div style={{ display: "none" }} element={<Button id="export-data-button" className="export-data-button" onClick={this.getFileName} data-tut="reactour__downloads">Download</Button>} filename={this.state.fileName}>
                                            {this.props.downloadResult && this.props.downloadResult.length > 0 ?
                                                <div data={this.props.downloadResult} name="Results">
                                                    <div label="SampleID" value={(col) => col.sample.sample_id} />
                                                    <div label="EF Barcode" value={(col) => col.sample.barcode} />
                                                    <div label="BatchNumber" value={(col) => col.sample.batch_no} />
                                                    <div label="TypeOfSample" value={(col) => col.sample.type_of_samples} />
                                                    <div label="TypeOfAnalysis" value={(col) => col.sample.type_of_analysis} />
                                                    <div label="OrganismName" value={(col) => col.sample.organism} />
                                                    <div label="LocationID" value={(col) => col.sample.unit ? col.sample.location.location_id + ', ' + col.sample.unit.unit_id : col.sample.location.location_id} />
                                                    <div label="Date_Time" value={(col) => moment(col.sample.date_time).format('MMMM D, YYYY HH:mm')} />
                                                    <div label="Comments" value={(col) => col.sample.comments} />
                                                    <div label="MicrobiomeResults" value={(col) => JSON.stringify(this.refineBiomeValue(col.analysis_result_data))} />
                                                </div>
                                                : null
                                            }
                                        </div>
                                    }
                                    {!localStorage.getItem("guest") ? <Button
                                        className="export-data-button"
                                        id="export-data-button"
                                        labelColor="#000"
                                        backgroundColor="#FFF"
                                        fullWidth={true}
                                        onClick={() => this.toggleUploadModal()}
                                        data-tut="reactour__uploads"
                                    ><img src={uploadIcon} className="nav-icons" alt='' />
                                        Upload Results
                                    </Button> : null}
                                    <Modal isOpen={this.state.isUploadModalOpen} toggle={this.toggleUploadModal} size="lg">
                                        <ModalHeader toggle={this.toggleUploadModal} className="edit-popup">Upload Results</ModalHeader>
                                        <ModalBody className="upload-body">
                                            <Row xs="2">
                                                <Col>
                                                    <FontAwesomeIcon className="overlay-upload-icon upload-sample-icon-position" icon={faUpload} size="lg" />
                                                    <Input
                                                        className="edit-input-values edit-input-values-file upload-sample-file"
                                                        type="file"
                                                        accept=".xlsx, .csv"
                                                        placeholder="please enter file"
                                                        onClick={(event) => {
                                                            event.target.value = null
                                                        }}
                                                        onChange={this.onChangeFile}
                                                        data-title={'Choose File'}
                                                    />
                                                </Col>
                                                <Col className="upload-sample-last">
                                                    {this.state.resultFile ?
                                                        <Col className="upload-filename">
                                                            <Label className="title">{this.state.resultFile.displayName}</Label>
                                                            <img src={deleteIconRed} className="overlay-upload-icon trash-icon" alt=''
                                                                onClick={this.clearUpload}
                                                            />
                                                        </Col> : <></>}
                                                </Col>
                                                <Col>
                                                    <div className="vertical-line"></div>
                                                    <div style={{ display: "none" }} element={<Button id="export-data-button" className="export-data-button  sample-template-button" onClick={this.getFileName}>Download Result Template</Button>} filename={this.state.fileName}>
                                                        <div data={dataset} name="Results">
                                                            <div label="*BarCode" value="barcode" />
                                                            <div label="batchnumber" value="bn" />
                                                            <div label="typeofsample" value="typeOfSample" />
                                                            <div label="*typeofanalysis" value="typeOfAnalysis" />
                                                            <div label="*locationid" value="locationId" />
                                                            <div label="*datetime" value="dateTime" />
                                                            <div label="comments" value="comments" />
                                                            <div label="*results" value="results" />
                                                        </div>
                                                    </div>
                                                    <div className="edit-popup">
                                                        <h5 className="modal-text lowertag lowertag-align">* are mandatory to fill</h5>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter className="float-sm-right bottom-options">
                                            <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={this.clearUpload}>Clear</Button>
                                            <Button
                                                className="button-size custom-button save-upload-delete-button"
                                                id="export-data-button"
                                                labelColor="#000"
                                                backgroundColor="#FFF"
                                                fullWidth={true}
                                                onClick={() => this.uploadResults()}
                                            >
                                                Save
                                            </Button>
                                            {this.state.loader ? <Spinner className="loader-save" size="sm" color="primary" /> : null}
                                        </ModalFooter>
                                    </Modal>

                                </Col>
                            </Row>
                            {this.state.loaderBiomeResults ?
                                <>
                                    <div className="loader-result-oval"><Oval color="#243682" height={60} width={60} /></div>
                                    <div className="no-data-msg"> Please wait while we check for Results...</div>
                                </>
                                :
                                <>
                                    {this.props.downloadResult.length > 0 ?
                                        <div>
                                            <div className="sample-table-height" data-tut="reactour__table">
                                                <ReactTable className="Data-Table"
                                                    PaginationComponent={Pagination}
                                                    data={this.props.downloadResult}
                                                    columns={this.columns}
                                                    showPagination={true}
                                                    minRows={0}
                                                    sortable={false}
                                                    defaultPageSize={5}
                                                    filterable={true}
                                                    filtered={this.state.filtered}
                                                    getTheadFilterTrProps={() => {
                                                        return {
                                                            style: this.state.isFilterEnabled ? {
                                                            }
                                                                :
                                                                { display: "none", visibility: "hidden" }
                                                        };
                                                    }}
                                                    onFilteredChange={(filtered, column, value) => {
                                                        this.onFilteredChangeCustom(value, column.id || column.accessor);
                                                    }}
                                                    defaultFilterMethod={(filter, row, column) => {
                                                        const id = filter.pivotId || filter.id;
                                                        if (typeof filter.value === "object" && filter.value !== null) {
                                                            return row[id] !== undefined
                                                                ? filter.value.indexOf(row[id]) > -1
                                                                : true;
                                                        } else {
                                                            return row[id] !== undefined
                                                                ? String(row[id]).indexOf(filter.value) > -1
                                                                : true;
                                                        }
                                                    }}
                                                    getTrProps={(state, rowInfo) => {
                                                        if (rowInfo && rowInfo.row) {
                                                            return {
                                                                onClick: () => { this.handleCheckClick(rowInfo.index) },
                                                                className: this.state.checked.includes(rowInfo.index) ? "table-selected-row" : "",
                                                            }
                                                        } else {
                                                            return {}
                                                        }
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>
                                        :
                                        <>
                                            {this.props.downloadResult.length === 0 ?
                                                <div className="no-data-msg"> No Results Available</div>
                                                :
                                                null
                                            }
                                        </>
                                    }
                                </>
                            }
                        </div>
                        <Modal isOpen={this.state.isMultiDeleteModalOpen} toggle={this.toggleMultiDeleteModal}>
                            <ModalHeader toggle={this.toggleMultiDeleteModal} className="edit-popup delete-title">
                                <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle} />
                                Warning
                            </ModalHeader>
                            {this.state.checked.length > 1 ?
                                <ModalBody className="delete-popup-body">
                                    Do you want to delete the {this.state.checked.length} results selected?
                                </ModalBody> :
                                <ModalBody className="delete-popup-body">
                                    Do you want to delete the result {this.state.checked.map((data) => this.props.downloadResult[data].sample.barcode)[0]}?
                                </ModalBody>}
                            <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                                <Button className="custom-button cancel-button mr-2 custom-dimension" outline color="secondary" onClick={this.toggleMultiDeleteModal}>No</Button>
                                <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteMultipleSamples}>Yes</Button>
                            </ModalFooter>
                        </Modal>

                        {/*  */}
                        <Modal isOpen={this.state.isChartModalOpen} toggle={this.toggleChartModal} size="xl">
                            <ModalHeader toggle={this.toggleChartModal} className="edit-popup">
                                Abundância Relativa de Espécies
                            </ModalHeader>
                            <ModalBody>
                                {(() => {
                                    const chartData = this.getChartData();
                                    const species = this.getSpeciesList();
                                    const COLORS = [
                                        '#4e79a7', '#f28e2b', '#e15759', '#76b7b2',
                                        '#59a14f', '#edc948', '#b07aa1', '#ff9da7',
                                        '#9c755f', '#bab0ac'
                                    ];
                                    return (
                                        <div style={{ width: '100%', height: Math.max(300, chartData.length * 60) }}>
                                            <ResponsiveContainer width="100%" height="100%">
                                                <BarChart
                                                    layout="vertical"
                                                    data={chartData}
                                                    margin={{ top: 10, right: 30, left: 120, bottom: 10 }}
                                                >
                                                    <CartesianGrid strokeDasharray="3 3" />
                                                    <XAxis
                                                        type="number"
                                                        domain={[0, 100]}
                                                        tickFormatter={v => `${v}%`}
                                                        label={{ value: 'Abundância Relativa (%)', position: 'insideBottom', offset: -5 }}
                                                    />
                                                    <YAxis
                                                        type="category"
                                                        dataKey="barcode"
                                                        width={110}
                                                        tick={{ fontSize: 11 }}
                                                    />
                                                    <Tooltip formatter={(value, name) => [`${value}%`, name]} />
                                                    <Legend verticalAlign="top" />
                                                    {species.map((sp, idx) => (
                                                        <Bar
                                                            key={sp}
                                                            dataKey={sp}
                                                            stackId="a"
                                                            fill={COLORS[idx % COLORS.length]}
                                                        />
                                                    ))}
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                    );
                                })()}
                            </ModalBody>
                            <ModalFooter>
                                <Button outline color="secondary" onClick={this.toggleChartModal}>Fechar</Button>
                            </ModalFooter>
                        </Modal>
                        <ToastContainer autoClose={3000} />
                        {this.props.isTourOpen ? <Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} /> : null}
                    </div>
                }
            </>
        )
    }
}

const mapStateToProps = state => {

    return {
        downloadResult: state.results_data.downloadBiomeResultData,
        resultPagination: state.results_data.allPagination,
        filters: state.results_data.filters,
        locationList: state.sample_data.locationList,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
        initialState: state.results_data.initialState,
        resultParams: state.results_data.resultParams
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        downloadBiomeResultData,
        deleteMultipleResult,
        fetchFilterOptions,
        saveSample,
        fetchBuilding,
        fetchLocationList,
        deleteResult,
        updateSample,
        fetchResultInitialState,
        updateResultStateFilters,
        uploadResults
    }
)(microbiomeResultsList), 'microbiomeResultsList GridView', 'microbiomeResultsList');